/**
 * Coerces a raw form value into a non-negative number.
 * @param value - The number or string to normalize
 * @returns The clamped number, or null when the value is empty or not a number
 */
export function normalizeNonNegativeNumber(
    value: number | string | null | undefined
): number | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
        return null;
    }

    return Math.max(0, numericValue);
}
